import React, { useEffect, useState } from 'react';
import LiveTripCards from 'components/live-trip-cards';
import { ReactComponent as EmptyIcon } from 'assets/icons/empty-search-result.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import { apiService } from 'utils/api';
import { ENUM_SEARCH_KEY } from 'utils/enum';
import { useNavigate, useParams } from 'react-router-dom';
import { OrderType } from 'models/order.model';

const OrderResultSideModal = () => {
  const { filterValue: filter_value } = useParams();
  const navigate = useNavigate();
  if (!filter_value) navigate(-1);

  const [loading, setLoading] = useState(true);
  const [localOrders, setLocalOrders] = useState<OrderType[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [totalLength, setTotalLength] = useState(0);

  const handleSearch = async () => {
    const data = { filter_type: ENUM_SEARCH_KEY.ORDER_CODE, filter_value, page: pageNumber };
    const res = await apiService.get(`cs/search/keyword`, {
      params: data,
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    const newData = res.data.data;
    const allOrders = [...localOrders, ...newData];
    setTotalLength(res.data.total);
    setLocalOrders(allOrders);
    if (allOrders.length === 0) setLoading(false);
  };

  useEffect(() => {
    handleSearch();
  }, [pageNumber]);

  useEffect(() => {
    setHasMore(localOrders.length < totalLength);
    if (localOrders.length > 0) setLoading(false);
  }, [localOrders]);

  const fetchMoreData = () => {
    setPageNumber((p) => p + 1);
  };

  return loading ? (
    <div className='flex justify-center items-center'>
      <div>
        <p className='py-3 leading-10'>Loading...</p>
      </div>
    </div>
  ) : localOrders.length === 0 ? (
    <div className='flex justify-center items-center mt-5'>
      <div>
        <EmptyIcon />
        <p className='py-3'>No search result found</p>
      </div>
    </div>
  ) : (
    <InfiniteScroll
      hasMore={hasMore}
      next={() => fetchMoreData()}
      dataLength={localOrders.length}
      loader={<p className='text-center mt-8'>Loading more orders...</p>}
      endMessage={<p className='text-center mt-8'>End of list</p>}>
      <LiveTripCards orders={localOrders} />
    </InfiniteScroll>
  );
};

export default OrderResultSideModal;
